<div fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="row">{{ "stress-group.title" | translate }} </h2>
    <div *ngIf="topMenuIcons.length > 0">

        <button mat-raised-button *ngFor="let action of topMenuIcons" [routerLink]="action.routerLink"
            (click)="this[action.clickMethod]()">
            <mat-icon [title]="action.title"> {{ action.icon }} </mat-icon>
        </button>
    </div>
</div>
<form [formGroup]="detailForm">
    <div fxLayout="column">
        <div fxLayout="row wrap" fxLayoutGap="40px">
            <mat-form-field *ngIf="columnsVisible.get('id')" [ngStyle]="{
            'width.ch': detailForm.controls['id'].value ? detailForm.controls['id'].value.length : 10,
            'min-width.px': 200
          }">
                <mat-label> {{ "stress-group.id" | translate }} </mat-label>
                <input matInput [ngStyle]="{
              'width.ch': detailForm.controls['id'].value ? detailForm.controls['id'].value.length : 10,
              'min-width.px': 180
            }" formControlName="id" />
            </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('calcStatus')" [ngStyle]="{
          'width.ch': detailForm.controls['calcStatus'].value ? detailForm.controls['calcStatus'].value.length : 10,
          'min-width.px': 200
        }">
                <mat-label>{{ "stress-group.calc-status" | translate }}</mat-label>
                <input matInput class="form-control" [ngStyle]="{
            'width.ch': detailForm.controls['calcStatus'].value ? detailForm.controls['calcStatus'].value.length : 10,
            'min-width.px': 180
          }" formControlName="calcStatus" />

            </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('groupType')" [ngStyle]="{
                'width.ch': detailForm.controls['groupType'].value ? detailForm.controls['groupType'].value.length : 10,
                'min-width.px': 200
              }">
                      <mat-label>{{ "stress-group.group-type" | translate }}</mat-label>
                      <input matInput class="form-control" [ngStyle]="{
                  'width.ch': detailForm.controls['groupType'].value ? detailForm.controls['groupType'].value.length : 10,
                  'min-width.px': 180
                }" [value]="detailForm.controls['groupType'].value.replace('GROUP_', '')"  disabled="true"/>

                  </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('created')" [ngStyle]="{
            'width.ch': detailForm.controls['created'].value ? detailForm.controls['created'].value.length : 10,
            'min-width.px': 200
         }">
                <mat-label>{{ "stress-group.creation-date" | translate }}</mat-label>
                <input matInput [disabled]='true' value="{{ group.created | date:'yyyy-MM-dd HH:mm' }}"
                    class="form-control" [ngStyle]="{
             'width.ch': detailForm.controls['created'].value ? detailForm.controls['created'].value.length : 10,
             'min-width.px': 180
         }" />

            </mat-form-field>


            <mat-form-field *ngIf="columnsVisible.get('lastModificationDate')" [ngStyle]="{
            'width.ch': detailForm.controls['lastModificationDate'].value ? detailForm.controls['lastModificationDate'].value.length : 10,
            'min-width.px': 200
         }">
                <mat-label>{{ "stress-group.modification-date" | translate }}</mat-label>
                <input matInput [disabled]='true' value="{{ group.lastModificationDate| date:'yyyy-MM-dd HH:mm' }}"
                    class="form-control" [ngStyle]="{
             'width.ch': detailForm.controls['lastModificationDate'].value ? detailForm.controls['lastModificationDate'].value.length : 10,
             'min-width.px': 180
         }" />

            </mat-form-field>
        </div>

        <div fxLayout="row wrap" fxLayoutGap="40px">

            <mat-form-field *ngIf="columnsVisible.get('minDepthSoil')" [ngStyle]="{
              'width.ch': detailForm.controls['minDepthSoil'].value ? detailForm.controls['minDepthSoil'].value.length : 10,
              'min-width.px': 200
            }">
              <mat-label>{{ "stress-group.min-depth-soil" | translate }}</mat-label>
              <input matInput type="number" class="form-control" [ngStyle]="{
                'width.ch': detailForm.controls['minDepthSoil'].value ? detailForm.controls['minDepthSoil'].value.length : 10,
                'min-width.px': 180
              }" formControlName="minDepthSoil" />

          </mat-form-field>

          <mat-form-field *ngIf="columnsVisible.get('maxDepthSoil')" [ngStyle]="{
            'width.ch': detailForm.controls['maxDepthSoil'].value ? detailForm.controls['maxDepthSoil'].value.length : 10,
            'min-width.px': 200
          }">
            <mat-label>{{ "stress-group.max-depth-soil" | translate }}</mat-label>
            <input matInput type="number" class="form-control" [ngStyle]="{
              'width.ch': detailForm.controls['maxDepthSoil'].value ? detailForm.controls['maxDepthSoil'].value.length : 10,
              'min-width.px': 180
            }" formControlName="maxDepthSoil" />
        </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('minGravelThickness')" [ngStyle]="{
                'width.ch': detailForm.controls['minGravelThickness'].value ? detailForm.controls['minGravelThickness'].value.length : 10,
                'min-width.px': 200
              }">
                <mat-label>{{ "stress-group.min-gravel-thickness" | translate }}</mat-label>
                <input matInput type="number" class="form-control" [ngStyle]="{
                  'width.ch': detailForm.controls['minGravelThickness'].value ? detailForm.controls['minGravelThickness'].value.length : 10,
                  'min-width.px': 180
                }" formControlName="minGravelThickness" />

            </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('maxGravelThickness')" [ngStyle]="{
                'width.ch': detailForm.controls['maxGravelThickness'].value ? detailForm.controls['maxGravelThickness'].value.length : 10,
                'min-width.px': 200
              }">
                <mat-label>{{ "stress-group.max-gravel-thickness" | translate }}</mat-label>
                <input matInput type="number" class="form-control" [ngStyle]="{
                  'width.ch': detailForm.controls['maxGravelThickness'].value ? detailForm.controls['maxGravelThickness'].value.length : 10,
                  'min-width.px': 180
                }" formControlName="maxGravelThickness" />

            </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('stressPatternAvg')" [ngStyle]="{
                          'width.ch': detailForm.controls['stressPatternAvg'].value ? detailForm.controls['stressPatternAvg'].value.length : 10,
                          'min-width.px': 200
                        }">
              <mat-label>{{ "stress-group.stressPattern-avg" | translate }}</mat-label>
              <input matInput type="number" class="form-control" [ngStyle]="{
                            'width.ch': detailForm.controls['stressPatternAvg'].value ? detailForm.controls['stressPatternAvg'].value.length : 10,
                            'min-width.px': 180
                          }" formControlName="stressPatternAvg" />

            </mat-form-field>

            <mat-form-field [ngStyle]="{ 'width.ch':  10, 'min-width.px': 200 }">
              <mat-label>{{ "stress-area.maxErrorPerc" | translate }}</mat-label>
              <input matInput type="number" class="form-control" [ngStyle]="{
                'width.ch': 10,
                'min-width.px': 100
              }" [value]="getMaxPerc()" disabled />
            </mat-form-field>

          <mat-form-field *ngIf="columnsVisible.get('longHardEdgeErrorPerc')" [ngStyle]="{
            'width.ch': detailForm.controls['longHardEdgeErrorPerc'].value ? detailForm.controls['longHardEdgeErrorPerc'].value.length : 10,
            'min-width.px': 200
          }">
          <mat-label>{{ "stress-area.longHardEdgeErrorPerc" | translate }}</mat-label>
          <input matInput type="number" class="form-control" [ngStyle]="{
                        'width.ch': detailForm.controls['longHardEdgeErrorPerc'].value ? detailForm.controls['longHardEdgeErrorPerc'].value.length : 10,
                        'min-width.px': 180
                      }" formControlName="longHardEdgeErrorPerc" />
        </mat-form-field>
        <mat-form-field *ngIf="columnsVisible.get('longHardCenterErrorPerc')" [ngStyle]="{
          'width.ch': detailForm.controls['longHardCenterErrorPerc'].value ? detailForm.controls['longHardCenterErrorPerc'].value.length : 10,
          'min-width.px': 200
        }">
        <mat-label>{{ "stress-area.longHardCenterErrorPerc" | translate }}</mat-label>
        <input matInput type="number" class="form-control" [ngStyle]="{
                      'width.ch': detailForm.controls['longHardCenterErrorPerc'].value ? detailForm.controls['longHardCenterErrorPerc'].value.length : 10,
                      'min-width.px': 180
                    }" formControlName="longHardCenterErrorPerc" />
      </mat-form-field>
      <mat-form-field *ngIf="columnsVisible.get('longOverallErrorPerc')" [ngStyle]="{
        'width.ch': detailForm.controls['longOverallErrorPerc'].value ? detailForm.controls['longOverallErrorPerc'].value.length : 10,
        'min-width.px': 200
      }">
      <mat-label>{{ "stress-area.longOverallErrorPerc" | translate }}</mat-label>
      <input matInput type="number" class="form-control" [ngStyle]="{
                    'width.ch': detailForm.controls['longOverallErrorPerc'].value ? detailForm.controls['longOverallErrorPerc'].value.length : 10,
                    'min-width.px': 180
                  }" formControlName="longOverallErrorPerc" />
    </mat-form-field>
    <mat-form-field *ngIf="columnsVisible.get('longTwistErrorPerc')" [ngStyle]="{
      'width.ch': detailForm.controls['longTwistErrorPerc'].value ? detailForm.controls['longTwistErrorPerc'].value.length : 10,
      'min-width.px': 200
    }">
    <mat-label>{{ "stress-area.longTwistErrorPerc" | translate }}</mat-label>
    <input matInput type="number" class="form-control" [ngStyle]="{
                  'width.ch': detailForm.controls['longTwistErrorPerc'].value ? detailForm.controls['longTwistErrorPerc'].value.length : 10,
                  'min-width.px': 180
                }" formControlName="longTwistErrorPerc" />
  </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('tunnelSection')" [ngStyle]="{
                                'width.ch':  10,
                                'min-width.px': 200
                              }">
                <mat-label>{{ "stress-area.tunnel-section" | translate }}</mat-label>
                <input matInput class="form-control" [ngStyle]="{
                                  'width.ch': 10,
                                  'min-width.px': 180}"
                    value="{{ group && group.tunnelSection ? group.tunnelSection.name : '' }}"
                    [disabled]="true"
                     />

            </mat-form-field>
        </div>
        </div>

</form>
